import caliberHomeLoans from 'mortgage-combined/assets/lenders/caliber.png'
import loanDepot from 'mortgage-combined/assets/lenders/loandepot.png'
import unitedWholesaleMortgage from 'mortgage-combined/assets/lenders/uwm.png'
import stearnsMortgage from 'mortgage-combined/assets/lenders/stearns.png'
import quickenLoans from '@cred/global-assets/images/logos/rocket-mortgage/RocketMortgage-RGB-Horizontal-2048px.png'

export default (slug) => {
  const images = {
    caliber_home_loans: caliberHomeLoans,
    loan_depot: loanDepot,
    quicken_loans: quickenLoans,
    united_wholesale_mortgage: unitedWholesaleMortgage,
    stearns: stearnsMortgage,
  }

  return images[slug]
}
